import { ProfileTypeEnum } from '../../models/user-profile';

export interface GoalsReportLock {
  locked: boolean;
  message: string;
  target: 'skills-survey' | 'career-goal' | null;
}

interface ProfileLike {
  isSkillsSurveyComplete?: boolean;
  profileType?: string;
}

// BUG-590: the Goals Report needs a completed skills survey AND a career goal
// (mirrors the server-side isSkillsSurveyComplete computation plus the goal
// check). The lock message must name the prerequisites the user is actually
// missing: quick-match and civilian users never saw the military background
// questions, so telling them about military occupations is a dead end.
export function computeGoalsReportLock(
  isCareerGoalSet: boolean,
  profile: ProfileLike | null | undefined
): GoalsReportLock {
  const missingSkillsSurvey = !profile?.isSkillsSurveyComplete;
  const missingCareerGoal = !isCareerGoalSet;

  if (!missingSkillsSurvey && !missingCareerGoal) {
    return { locked: false, message: '', target: null };
  }

  if (missingSkillsSurvey && missingCareerGoal) {
    return {
      locked: true,
      message:
        'Take the skills survey and set a career goal to unlock your Goals Report. Click to start the survey.',
      target: 'skills-survey'
    };
  }

  if (missingSkillsSurvey) {
    const startedMilitaryPath =
      profile?.profileType === ProfileTypeEnum.ActiveDuty;
    return {
      locked: true,
      message: startedMilitaryPath
        ? 'Finish the skills survey, including the military background questions, to unlock your Goals Report. Click to continue the survey.'
        : 'Take the skills survey to unlock your Goals Report. Click to start the survey.',
      target: 'skills-survey'
    };
  }

  return {
    locked: true,
    message:
      'Set a career goal to unlock your Goals Report. Click to choose a career goal.',
    target: 'career-goal'
  };
}
